import duDialog from "@dmuy/dialog";
import extend from 'quasar/src/utils/extend/extend.js';
// duDialog のラッパーになってます
// https://github.com/dmuy/duDialog
export var MsgBoxButtons;
(function (MsgBoxButtons) {
    MsgBoxButtons[MsgBoxButtons["None"] = 0] = "None";
    MsgBoxButtons[MsgBoxButtons["OK"] = 1] = "OK";
    MsgBoxButtons[MsgBoxButtons["OKCancel"] = 2] = "OKCancel";
})(MsgBoxButtons || (MsgBoxButtons = {}));
const defaultOptions = {
    title: null,
    id: "msgbox",
    init: false,
    dark: false,
    buttons: MsgBoxButtons.OK,
    okText: "OK",
    cancelText: "キャンセル",
    selection: false,
    multiple: false,
    minSelect: 1,
    maxSelect: null,
    allowSearch: false,
    selectedValue: null,
    valueField: "value",
    textField: "item",
    callbacks: null
};
export class MsgBox {
    static options = new Promise(resolve => {
        resolve(defaultOptions);
    });
    static configure(configure) {
        this.options = new Promise(resolve => {
            configure(defaultOptions);
            resolve(defaultOptions);
        });
    }
    /** メッセージを表示します。 */
    static info(message, title = null) {
        return MsgBox.show(message, {
            title,
            buttons: MsgBoxButtons.OK
        });
    }
    /** 確認メッセージを表示します。 */
    static confirm(message, title = null) {
        return MsgBox.show(message, {
            title,
            buttons: MsgBoxButtons.OKCancel
        });
    }
    /** negativeな確認メッセージを表示します。 */
    static negativeConfirm(message, title = null) {
        return MsgBox.show(message, {
            title,
            id: "msgbox-negative",
            buttons: MsgBoxButtons.OKCancel
        });
    }
    /** エラーメッセージを表示します。 */
    static error(message, title = null) {
        if (!message) {
            return Promise.resolve(false);
        }
        return MsgBox.show(message, {
            title,
            id: "msgbox-error",
            buttons: MsgBoxButtons.OK
        });
    }
    /** メッセージボックスを表示します */
    static async show(message, options) {
        let opt = extend(true, {}, await this.options, options);
        return new Promise(resolve => {
            opt.init = true;
            opt.callbacks = opt.callbacks || {};
            opt.callbacks.okClick = function () {
                this.hide();
                resolve(true);
            };
            opt.callbacks.cancelClick = function () {
                this.hide();
                resolve(false);
            };
            let dialog = new duDialog(opt.title, message, opt);
            dialog.show();
        });
    }
}
